import api from './api';

const BusinessService = {
  GetAllBusinesses: () => {
    return api
      .get('/Client/GetAllBusiness')
      .then(response => {
        console.log('✅ BusinessService - GetAllBusinesses Success:', response.data);
        return response;
      })
      .catch(error => {
        console.error('❌ BusinessService - GetAllBusinesses Error:', error);
        throw error;
      });
  },

  AddBusiness: (data) => {
    if (!data?.business_name) {
      return Promise.reject(new Error("Business name is required"));
    }

    console.log('🔄 BusinessService - AddBusiness Data:', data);

    return api
      .post('/Client/AddBusiness', null, {
        params: {
          business_name: data.business_name,
          industry_type: data.industry_type || "",
          client_id: data.client_id || ""
        }
      })
      .then(response => {
        console.log('✅ BusinessService - AddBusiness Success:', response.data);
        return response;
      })
      .catch(error => {
        console.error('❌ BusinessService - AddBusiness Error:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
      });
  },

  // Get Business Interaction Log
  GetBusinessInteractionLog: (businessId, clientId) => {
    console.log('🔄 BusinessService - GetBusinessInteractionLog Params:', { businessId, clientId });

    const params = {};
    if (businessId) params.business_id = businessId;
    if (clientId) params.client_id = clientId;

    return api
      .get('/Client/GetBusinessInteractionLog', {
        params: params
      })
      .then(response => {
        console.log('✅ BusinessService - GetBusinessInteractionLog Success:', response.data);
        return response;
      })
      .catch(error => {
        console.error('❌ BusinessService - GetBusinessInteractionLog Error:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
      });
  },

  // Add Business Log
  AddBusinessLog: (data) => {
    console.log('🔄 BusinessService - AddBusinessLog Data:', data);

    // Prepare query parameters
    const params = new URLSearchParams({
      client_id: data.client_id || '',
      business_id: data.business_id || '',
      contact_person: data.contact_person || '',
      log_type: data.log_type || 'call',
      log_subject: data.log_subject || '',
      log_notes: data.log_notes || '',
      log_date: data.log_date || new Date().toISOString().split('T')[0]
    }).toString();

    return api
      .post(`/BusinessLog/AddBusinessLog?${params}`)
      .then(response => {
        console.log('✅ BusinessService - AddBusinessLog Success:', response.data);
        return response;
      })
      .catch(error => {
        console.error('❌ BusinessService - AddBusinessLog Error:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
      });
  },

  // Delete Business Log
  DeleteBusinessLog: (logId) => {
    if (!logId) {
      return Promise.reject(new Error("Log ID is required"));
    }

    return api
      .delete(`/BusinessLog/DeleteBusinessLog?log_id=${logId}`)
      .then(response => {
        console.log('✅ BusinessService - DeleteBusinessLog Success:', response.data);
        return response;
      })
      .catch(error => {
        console.error('❌ BusinessService - DeleteBusinessLog Error:', error);
        throw error;
      });
  }
};

export default BusinessService;